/**
 * External dependencies.
 */
import { applyMiddleware, createStore } from 'redux';
import { persistStore, persistReducer, autoRehydrate } from 'redux-persist'
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'

/**
 * Internal dependencies.
 */
import reducer from '../reducers';
import sagas from '../sagas';

// Create the saga middleware.
const sagaMiddleware = createSagaMiddleware();

// Create persist config.
const persistConfig = {
	key: window.wizardData.persist_key,
	storage,
	stateReconciler: hardSet,
}

// Create persisted reducer.
const persistedReducer = persistReducer(persistConfig, reducer);

// Create store and persistor.
export const store = createStore( persistedReducer, applyMiddleware( sagaMiddleware ) )
export const persistor = persistStore(store)

// Run the saga.
sagaMiddleware.run(sagas);